<template>
  <v-container
    fluid
    pa-0
  >
    <v-row>
      <v-col
        v-if="title"
        cols="12"
      >
        <div class="d-flex align-center brand-green-dark--text">
          <v-icon
            class="mr-6"
            color="brand-green-dark"
          >
            mdi-account-credit-card
          </v-icon>

          <h2 class="d-inline-block brand-text-heading">
            {{ toLocaleUpperCase(title) }}
          </h2>
        </div>
      </v-col>

      <v-col cols="12">
        <v-list
          class="pa-0"
          color="transparent"
          two-line
        >
          <v-list-item-group
            v-model="vModel"
            color="brand-primary"
            mandatory
          >
            <template v-for="(item, i) in paymentMethods">
              <v-list-item
                v-if="item.Status"
                :key="i"
                :value="item"
              >
                <v-list-item-icon
                  v-if="item.Icon"
                  class="my-auto"
                >
                  <v-icon
                    v-text="item.Icon"
                  />
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title
                    v-text="getTranslatedField(item)"
                  />

                  <v-list-item-subtitle class="text-caption">
                    {{ $t('Cart.Message.Info.MinimumOrder.Title') }} {{ paymentMinOrderTotal(item) | currency }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SelectPaymentMethodMixin from '@/theme/default/components/payment/common/SelectPaymentMethod.js'

export default {
  name  : 'SelectPaymentMethod',
  mixins: [SelectPaymentMethodMixin]
}
</script>

<style scoped src="@/theme/default/components/payment/common/SelectPaymentMethod.css"></style>

<style scoped>
</style>
